import { MoonIcon, SunIcon } from '@/lib/icons';
import { useTheme } from '@/lib/useTheme';
import { cn } from '@/lib/format';

/**
 * Theme is a persisted setting (UI/UX spec §3.1). The control is a labelled
 * toggle, not an icon-only mystery button.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={`Switch to ${next} mode`}
      title={`Switch to ${next} mode`}
      className={cn(
        'inline-flex h-10 w-10 items-center justify-center rounded-card border border-hairline',
        'text-ink transition-colors duration-150 hover:border-accent hover:text-accent',
        className,
      )}
    >
      {theme === 'dark' ? <SunIcon className="text-lg" /> : <MoonIcon className="text-lg" />}
    </button>
  );
}
